import { render, staticRenderFns } from "./DemoData.vue?vue&type=template&id=b8c48038&"
import script from "./DemoData.vue?vue&type=script&lang=js&"
export * from "./DemoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports